<app-bread-crumb [items]="[{text:  'subcategories',link:'/admin/settings/subcategory'},{text:pageTitle}]"
    [sectionTitle]="pageTitle"></app-bread-crumb>

<section class="content">

    <!-- inicio do formulário -->
    <form [formGroup]="objectForm" novalidate (ngSubmit)="submitForm()">

        <!-- inicio do box -->
        <ng-box [boxIcon]="'fa fa-list'" [boxTitle]="'Dados da Subategoria'" [showBoxFooter]="true">

            <!-- cabesalho do box -->
            <ng-container class="ng-box-header">
                <ng-button (click)="back()" [button]="{name:'back',faIconClass:'fa fa-arrow-left',color:'secondary'}">
                </ng-button>
            </ng-container>

            <!-- inicio do conteudo do box -->
            <ng-container class="ng-box-content">
                <div class="row">
                    <div class="col-md-6">
          
                      <div class="form-group">
          
                        <app-input label="Categoria(*)" errorMessage="Campo obrigatório">
                          <select formControlName="producto_categorias_id" class="form-control">
                            <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
                          </select>
                        </app-input>
          
                      </div>
          
                    </div>
                    <div class="col-md-6">
          
                      <div class="form-group">
          
                        <app-input label="Nome(*)" errorMessage="Campo obrigatório">
                          <input type="text" formControlName="name" class="form-control">
                        </app-input>
          
                      </div>
          
                    </div>
           
                  </div>
 
            </ng-container>

            <!-- fim do conteudo do box -->

            <!-- inicio do rodapé -->
            <ng-container class="ng-box-footer">
                <div class="row">
                    <div class="col-xs-12">
                        <ng-button class="pull-right" [button]="{
                            name:'salvar',
                            color:'danger',
                            faIconClass:'fa fa-save',
                            type:'submit',
                            loadingText:'SALVANDO',
                            isLoading:isButtonLoading,
                            isDisabled:isButtonLoading || objectForm.invalid}">
                        </ng-button>
                    </div>
                </div>
            </ng-container>
            <!-- fim do rodapé -->

        </ng-box>
        <!-- fim do box -->
    </form>
    <!-- fim do formulário -->
</section>